module.exports = __webpack_public_path__ + "static/media/left.3a34ed70.png";